import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

import { HeaderComponent } from './component/header/header.component';
import { HasRoleGuard } from './Guards/hasRole/has-role.guard';
import { LoginFailedComponent } from './component/login-failed/login-failed.component';
import { MsalRedirectComponentGuard } from './Guards/msal-redirect.guard/msal-redirect-component.guard';
import { FrequentlyQuestionsComponent } from './component/frequently-questions/frequently-questions.component';
import { ExpirationEnviromentGuard } from './Guards/expirationEnviroment/expiration-enviroment.guard';
import { municipalityTokenResolver } from './servicios/municipality-token/municipality-token.resolver';

const routes: Routes = [

  {
    path: 'auth', 
    component: MsalRedirectComponent, 
    canActivate: [MsalRedirectComponentGuard]
  },

  {
    path: '',
    canActivate: [MsalGuard, ExpirationEnviromentGuard],
    resolve: {
      municipality: municipalityTokenResolver
    },
    component: HeaderComponent,
    children: [
      {
        path: 'traffic',
        loadChildren: () => import('./modules/traffic/traffic.module').then(x => x.TrafficModule),
        canLoad: [HasRoleGuard], 
        data: { moduleId: '1' }
      },
      {
        path: 'management',
        loadChildren: () => import('./modules/management/management.module').then(x => x.ManagementModule),
        canLoad: [HasRoleGuard], 
        data: { moduleId: '2' }
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/administrate/administrate.module').then(x => x.AdministrateModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '3' }
      },
      { 
        path: 'telemetry',
        loadChildren: () => import('./modules/telemetry/telemetry.module').then(m => m.TelemetryModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '4' }
      },
      { 
        path: 'zar', // TODO: Se cambia temporalmente de nombre en las traducciones de 'Infracciones' a 'ZAR/ZBE' temporalmente
        loadChildren: () => import('./modules/zar/zar.module').then(m => m.ZarModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '9' }
      },
      {
        path: 'red-light',
        loadChildren: () => import('./modules/red-light/red-light.module').then(m => m.RedLightModule),
        canLoad: [HasRoleGuard],
        data: { moduleId: '10' }
      },
      {
        path: 'crosswalk',
        loadChildren: () => import('./modules/crosswalk/crosswalk.module').then(m => m.CrosswalkModule),
        canLoad: [HasRoleGuard],
        data: { moduleId: '12' }
      },
      {
        path: 'weather',
        loadChildren: () => import('./modules/weather/weather.module').then(x => x.WeatherModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '6' }
      },
      {
        path: 'waste',
        loadChildren: () => import('./modules/waste/waste.module').then(x => x.WasteModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '11' }
      },
      {
        path: 'developer',
        loadChildren: () => import('./modules/developer/developer.module').then(x => x.DeveloperModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '8' }
      },
       {
        path: 'help',
        loadChildren: () => import('./modules/help/help.module').then(x => x.HelpModule), 
        canLoad: [HasRoleGuard], 
        data: { moduleId: '103' }
      },
    ]
  },
  { path: "preguntas-frecuentes", component: FrequentlyQuestionsComponent },
  { path: "login-failed", component: LoginFailedComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes,  {enableTracing: false})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
